const commonErrorHelpListItems = {
    checkSpellingAndCapitalization:
        'Check the spelling and capitalization to ensure you are entering the information correctly.',
    contactSystemAdministratorIfStillUnableToAccess:
        'Contact your system administrator if you are still unable to access the web site.',
    contactSystemAdministratorForAssistance: 'Please contact your system administrator for assistance.',
    clickRefreshButton: 'Click your Refresh button or retype the web address into the address bar.',
    clickRefreshButtonWithSlowConnection:
        'Click your Refresh button or retype the web address into the address bar. If all web sites are running/loading slowly, your Internet connection may be having issues.',
    retryOrComeBackLater: 'Retry your previous activity or come back later.',
};

module.exports = {
    name: 'English',
    heading: {
        appTitle: 'Learning Continuum',
    },
    errors: {
        common: {
            helpList: {},
            pleaseTry: 'Please try the following:',
        },
        400: {
            header: 'Error 400 (Bad Request)',
            description: 'You are seeing this error message because the web address you typed is incorrect.',
            helpList: [
                commonErrorHelpListItems.checkSpellingAndCapitalization,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        401: {
            header: 'Error 401 (Unauthorized)',
            description: 'You are seeing this error message because the username or password you entered is incorrect.',
            helpList: [
                commonErrorHelpListItems.checkSpellingAndCapitalization,
                'Check whether your caps lock key is ON, as passwords are case-sensitive.',
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        403: {
            header: 'Error 403 (Forbidden)',
            description: 'You are seeing this error message because you do not have authorization to access this page.',
            helpList: [
                commonErrorHelpListItems.checkSpellingAndCapitalization,
                'Make sure the web address points to a web page and not a directory.',
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        404: {
            header: 'Error 404 (Not Found)',
            description: 'You are seeing this error message because we could not locate the page you requested.',
            helpList: [
                commonErrorHelpListItems.checkSpellingAndCapitalization,
                commonErrorHelpListItems.clickRefreshButton,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        405: {
            header: 'Error 405 (Method Not Allowed)',
            description: 'You are seeing this error message because your request could not be completed.',
            helpList: [commonErrorHelpListItems.contactSystemAdministratorForAssistance],
        },
        406: {
            header: 'Error 406 (Not Acceptable)',
            description: 'You are seeing this error message because your request could not be completed.',
            helpList: [commonErrorHelpListItems.contactSystemAdministratorForAssistance],
        },
        407: {
            header: 'Error 407 (Proxy Authentication Required)',
            description:
                'You are seeing this error message because the link you clicked points to a page for authorized users only.',
            helpList: [
                'Type your username/password again.',
                'If you are still unable to access your account after retrying, please contact your system administrator for assistance.',
            ],
        },
        408: {
            header: 'Error 408 (Request Timeout)',
            description: 'You are seeing this error message because your request took too long.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                'Try your request again later.',
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        409: {
            header: 'Error 409 (Conflict)',
            description:
                'You are seeing this error message because a shared document may be being edited by more than one person at the same time.',
            helpList: [
                'Please exit the system and retry your previous activity or come back later.',
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        500: {
            header: 'Error 500 (Internal Server Error)',
            description: 'You are seeing this error message because an unknown error has occurred.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                commonErrorHelpListItems.retryOrComeBackLater,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        502: {
            header: 'Error 502 (Bad Gateway)',
            description: 'You are seeing this error message because a network error has occurred.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                commonErrorHelpListItems.retryOrComeBackLater,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        503: {
            header: 'Error 503 (Service Unavailable)',
            description: 'You are seeing this error message because this website is currently unavailable.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                commonErrorHelpListItems.retryOrComeBackLater,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        504: {
            header: 'Error 504 (Gateway Timeout)',
            description: 'You are seeing this error message because a server is down or not working correctly.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                commonErrorHelpListItems.retryOrComeBackLater,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        1800: {
            header: 'App encountered an unexpected error',
            helpList: [
                commonErrorHelpListItems.clickRefreshButton,
                'Contact your system administrator if you are still unable to access the web site and notify them of the error in bold.',
            ],
        },
    },
    footers: {
        confidentiality: 'CONFIDENTIALITY NOTICE: this information may be confidential and legally protected from disclosure.',
        trademarks: () => {
          return `Lexile® and Quantile® are trademarks of MetaMetrics, Inc., and are registered in the United States and abroad. The trademarks and names of other companies and products mentioned herein are the property of their respective owners. Copyright © ${new Date(Date.now()).getFullYear()} MetaMetrics, Inc. All rights reserved.`;
        },
      },
    pageFooter: `This system contains confidential information that may be subject to applicable federal and state law. 
                 By accessing this system, you shall comply with such applicable laws, the terms and conditions of your 
                 agreement with HMH, and your entity’s policies regarding the use, transmission and handling of such 
                 confidential information.`,
};
